<template>
  <div>
    <v-col>
      <v-row v-if="showHead"
             align="center"
             justify="start"
             style="background-color:white">
        <v-col cols="2">
          <v-btn v-if="showHead"
                 @click="onexport"
                 text>
            <v-icon>cloud_download</v-icon>
            <div>
              Скачать
            </div>
          </v-btn>
        </v-col>
        <v-divider v-if="!showHead"
                   class="mx-2"
                   inset
                   vertical />
        <v-col cols="2">
          <v-checkbox v-model="showDeleted" label="Отображать удаленные" />
        </v-col>
        <v-col cols="5" offset="2">
          <v-row justify="center">
            <v-select ref="report_type"
                      v-if="headers.filter(v=> v.value==='report_type').length>0"
                      v-model="reportTypeFilter"
                      :items="reportTypeItems"
                      multiple
                      item-text="name"
                      item-value="name"
                      label="Отчет" />
            <!--        </v-col>-->
            <v-spacer />
            <!--        <v-col cols="3" offset="4">-->
            <v-text-field v-if="isSearchable"
                          v-model.trim="search"
                          append-icon="search"
                          label="Поиск"
                          single-line
                          hide-details />
          </v-row>
        </v-col>


        <v-col>
          <slot name="button" />
        </v-col>
      </v-row>
    </v-col>
    <v-card text color="white">
      <v-card-title v-if="!showHead">
        {{ tableName }}
        <v-spacer />
        <slot name="button" />
      </v-card-title>

      <v-data-table
        ref="sortableTable"
        :disabled="disabled"
        :headers="headers"
        :items="filteredData"
        :loading="loading"
        :search="search"
        :header-key="headerKey"
        :header-text="headerText"
        :group-by="groupBy"
        :hide-default-footer="hideActions"
        :no-data-text="noDataText"
        :no-results-text="noDataText"
        :items-per-page="50"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          itemsPerPageOptions:itemsPerPageItems,
          itemsPerPage: 50
        }"
        show-group-by

        class="elevation-1"
        sort-by="name">
        <template v-slot:item="props">
          <tr class="sortableRow">
            <td v-if="isDragable" class="px-1" style="width: 0.1%">
              <v-btn style="cursor: move" icon class="sortHandle">
                <v-icon>drag_handle</v-icon>
              </v-btn>
            </td>
            <td v-for="(value, key) in props.item"
                :key="key"
                :style="{display: (value && key==='id' || key==='deleted' || key==='importance' || headers.filter(v=>v.value===key && v.align==='d-none').length>0 ? 'none' : '[]' ),
                         opacity: (props.item['deleted'] === true ? 0.4 :1),
                         pointerEvents: (props.item['deleted'] === true ? 'none' :'auto')

                }">
              <template v-if="!Array.isArray(value)">
                {{ value && typeof value==='object' && 'name' in value ? value.name : value }}
              </template>
              <template v-else>
                <div v-for="item in value" :key="`item-${item.value ? item.value: item}-${props.item['id']}`">
                  {{ item.value ? item.value: item }}
                </div>
              </template>
            </td>
            <td v-if="!multipleEdit" :disabled="disabled" class="justify-center layout px-0">
              <v-icon
                v-if="!props.item['deleted']"
                :disabled="disabled"
                @click="editItem(props.item, props.index)"
                small
                class="mr-2">
                mdi-pencil
              </v-icon>
              <v-icon
                v-if="!props.item['deleted']"
                :disabled="disabled"
                @click="deleteItem(props.item, props.index)"
                small>
                mdi-delete
              </v-icon>
              <v-icon
                v-if="props.item['deleted']"
                :disabled="disabled"
                @click="recoverItem(props.item, props.index)"
                small>
                mdi-undo
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-if="alert" v-slot:no-data>
          <v-alert :value="true" color="warning" icon="warning">
            Обычно эти данные должны быть заполнены!
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar
      v-model="alertResult"
      :color="alertColor"
      :timeout="5000"
      top>
      {{ notificationText }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
import Sortable from 'sortablejs'
// import {requestOptions} from '../_helpers/auth-header'
import {authHeader} from '../../_helpers'
import {exportXls} from '../../utils'

export default {
    name: "BaseDataTable",
    props: {
      tableName: {
        type: String,
        default: 'Таблица'
      },
      headers: {
        type: Array,
        default: () => []
      },
      endpoint: {
        type: String,
        default: 'users'
      },
      editedItemVals: {
        type: Object,
        default: () => {
        }
      },
      hideActions: {
        type: Boolean,
        default: true
      },
      noDataText: {
        type: String,
        default: 'Нет данных'
      },
      headerKey: {
        type: String,
        default: undefined
      },
      headerText: {
        type: String,
        default: undefined
      },
      tableDataExternal: {
        type: Array,
        default: () => []
      },
      isLoading: {
        type: Boolean,
        default: true
      },
      async: {
        type: Boolean,
        default: true
      },
      isSearchable: {
        type: Boolean,
        default: true
      },
      alert: {
        type: Boolean,
        default: false
      },
      multipleEdit: {
        type: Boolean,
        default: false
      },
      enableExport: {
        type: Boolean,
        default: true
      },
      showHead: {
        type: Boolean,
        default: true
      },
      groupBy: {
        type: String,
        default: undefined
      },
      itemsPerPage: {
        type: Number,
        default: 50
      },
      isDragable: {
        type: Boolean,
        default: true
      },
      disabled:{
        type: Boolean,
        default: false
      }
    }
    ,
    data () {
      return {
        dialog: false,
        editedIndex: -1,
        editedItem: this.editedItemVals,
        tableData: this.tableDataExternal,
        loading: this.isLoading,
        reportTypeFilter: [],
        alertColor: 'green',
        notificationText: 'Данные успешно обновлены',
        itemsPerPageItems: [50, 100, 150, 200, -1],
        pagination: {
            itemsPerPage: 50
        },
        // perPage: this.pagination['rowsPerPage'],
        pages: [],
        page: 1,
        alertResult: false,
        showDeleted: false,
        search: "",
        headersPost: {
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).token, 'Content-Type':
            'application/json'
        }

      }
    },
    computed: {
      filteredData () {
        let vm = this
        let tabledata = this.tableData.filter(p => {
          return !vm.showDeleted ? p.deleted !== true : true
        })
        return tabledata.filter(p => vm.reportTypeFilter.length>0 ? vm.reportTypeFilter.some(v => p['report_type'].indexOf(v)>-1) : true)
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Добавить' : 'Отредактировать'
      },
      tableHeaders () {
        let vals = []
        this.headers.forEach(function (element) {
          vals.push(element.value)
        })
        return vals
      },
      json_fields () {
        let d = {}
        this.headers.forEach(head => {
          if (head['text'] !== 'Действия') d[head.value] = head['text']
        })
        return d
      }
    },
    watch: {
      tableDataExternal (newValue, oldValue) {
        this.tableData = newValue
      },
      editedItemVals (newValue, oldValue) {
        if (this.editedIndex > -1) {
          Object.assign(this.data[this.editedIndex], this.newValue)
        } else {
          this.data.push(this.newValue)
        }
      }
    },
    mounted () {
      /* eslint-disable no-new */
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onEnd: this.dragReorder
        }
      )
    },
    methods: {
      dragReorder ({oldIndex, newIndex}) {
        let tableCopy = this.filteredData.slice()
        const oldVal = tableCopy[newIndex]
        const newVal = tableCopy[oldIndex]
        tableCopy[newIndex] = newVal
        tableCopy[oldIndex] = oldVal
        // let vm = this
        tableCopy.forEach(function (part, index, theArray) {
          tableCopy[index].importance = index
        })
        // let vm = this
        if (this.tableDataExternal.length === 0) {
          axios({
            method: 'put',
            url: this.$store.state.tableData.backend + '/api/' + this.endpoint,
            headers: this.headersPost,
            data: tableCopy

          }).catch((error) => {
            throw new Error(`You can't load the data`)
          })
        }
      },
      clear () {
        this.tableData = []
      },
      editItem (item) {
        this.editedIndex = this.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$emit('editClick', this.editedItem, this.editedIndex)
      },
      deleteItem (item) {
        const index = this.data.indexOf(item)
        this.$emit('deleteClick', index)
        let vm = this
        if (this.async) {
          confirm('Are you sure you want to delete this item?') && this.$set(this.data[index], 'deleted', true)
          axios({
            method: 'delete',
            url: this.$store.state.tableData.backend + '/api/' + this.endpoint + '/' + item['id'],
            headers: this.headersPost,
            data: item

          }).then((res) => {
            vm.$store.dispatch("tableData/load"+ vm.capitalize(this.endpoint))
          }).catch((error) => {
            throw new Error(`You can't load the data`)
          })
        }
      },
      recoverItem (item) {
        const index = this.data.indexOf(item)
        item['deleted'] = false
        this.$emit('recoverClick', index)
        this.$set(this.data[index], 'deleted', false)
        axios({
          method: 'put',
          url: this.$store.state.tableData.backend + '/api/' + this.endpoint + '/' + item['id'],
          headers: this.headersPost,
          data: item

        }).catch((error) => {
          throw new Error(`You can't load the data`)
        })
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save (val) {
        let vm = this
        let index = this.editedIndex
        if (this.editedIndex > -1) {
          if (typeof val === 'string') val = JSON.parse(val)[0]
          axios({
            method: 'PUT',
            url: this.$store.state.tableData.backend + '/api/' + this.endpoint + '/' + val.id,
            headers: this.headersPost,
            data: val

          }).then((response) => {
            vm.alertColor = 'green'
            vm.notificationText = 'Данные успешно обновлены!'
            Object.assign(vm.tableData[index], response.data)
            vm.alertResult = true
            vm.$store.dispatch("tableData/load"+ vm.capitalize(vm.endpoint))
          }).catch((error) => {
            vm.alertColor = 'red'
            vm.notificationText = 'Что-то пошло не так!'
            vm.alertResult = true
            throw new Error(`You can't load the data`)
          })
        } else {
          delete val['id']
          let vm = this
          axios({
            method: 'POST',
            url: this.$store.state.tableData.backend + '/api/' + vm.endpoint,
            headers: this.headersPost,
            data: val

          }).then((response) => {
            let newVal = {}

            if (Array.isArray(response.data.response)) {
              response.data.response.forEach(val => {
                vm.tableHeaders.forEach(function (elem) {
                  if (elem in val) {
                    newVal[elem] = val[elem]
                  }
                })
              })
              vm.tableData.push(newVal)

            } else {
              vm.tableHeaders.forEach(function (elem) {
                if (elem in response.data.response) {
                  newVal[elem] = response.data.response[elem]
                }
              })
              vm.tableData.push(newVal)
            }
            vm.alertColor = 'green'
            vm.notificationText = 'Данные успешно обновлены!'
            vm.alertResult = true
            vm.$store.dispatch("tableData/load"+ vm.capitalize(vm.endpoint))

          }).catch((error) => {
            vm.alertColor = 'red'
            vm.notificationText = 'Что-то пошло не так!'
            vm.alertResult = true
            throw new Error(`You can't load the data`)
          })
        }
        this.close()
      },
      saveLocal (val) {
        let vm = this
        let index = this.editedIndex
        if (this.editedIndex > -1) {
          Object.assign(vm.tableData[index], val)
        } else {
          let newVal = {}
          vm.tableHeaders.forEach(function (elem) {
            if (elem in val) {
              newVal[elem] = val[elem]
            }
          })
          vm.tableData.push(newVal)
        }
      },
      onexport () { // On Click Excel download button
        let dataToExcel = this.tableData
        exportXls(dataToExcel, this.json_fields, this.tableName)
      }

    },
    asyncComputed: {
      data: {
        get () {
          const requestOptions = {
            method: 'GET',
            headers: authHeader()
          }

          if (this.async) {
            this.loading = true
            let vm = this
            return axios(this.$store.state.tableData.backend + '/api/' + this.endpoint, requestOptions).then((response) => {
              vm.tableData = response.data
              vm.loading = false
              return response.data
            }).catch((error) => {
              throw new Error(`You can't load the data`)
            })
          } else return this.tableDataExternal
        },
        default: []
      }
    }

  }
</script>


<style lang="scss" scoped>

  .capitalised-input input {
    text-transform: uppercase !important;
  }

  .hidden-header /deep/ {
    display: none !important;
  }
page-link {
	display: inline-block;
}
page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDataTable.vue